import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { MapPin, Phone, Mail, Clock, User, HelpCircle, AlertTriangle, FileText, Building, CheckCircle2, Globe } from 'lucide-react';
export function ContactUs() {
  usePageTitle('Contact Us | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1040" data-mp="2imq6qnicr5sb">
      <TopBar data-id="element-1041" data-mp="2ikwwyzcg05g3" />
      <Header data-id="element-1042" data-mp="2ikn9pjis8ce3" />
      <Navigation data-id="element-1043" data-mp="3p3bx8itoz6wr" />

      <main className="flex-grow" data-id="element-1044" data-mp="3p3v9biwnv12v">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1045" data-mp="3u26ehgc0gner">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1046" data-mp="3u49connbhmuk">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1047" data-mp="1f1uvdxfovqo4">
              We're Here to Help
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1048" data-mp="164khe4bhlnfi">
              Contact & FAQs
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-1049" data-mp="w53dnsfspjm6">
              Get in touch with our expert team for help choosing the right
              product, identifying a replacement part, or planning a commercial
              project.
            </p>
            <div className="flex justify-center" data-id="element-1050" data-mp="ie6lu3tp16g6">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Live%20Rep.png" alt="Live Representative at Midatlantic Mailbox" className="h-16 object-contain" data-id="element-1051" data-mp="ddsnjdhw9avc" />
            </div>
          </div>
        </section>

        {/* Contact Info & Hours */}
        <section className="py-16 bg-brand-goldWash border-b border-brand-border" data-id="element-1052" data-mp="3rhqme6h5ffl">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1053" data-mp="3lx4fzm9kcrx7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1054" data-mp="3pxejms9vv68w">
              {/* Main Office */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1055" data-mp="hhuy6ffges4e">
                <div className="flex items-center gap-3 mb-6" data-id="element-1056" data-mp="mgo9q2b6k91x">
                  <div className="w-12 h-12 rounded-full bg-brand-background text-brand-maroon flex items-center justify-center" data-id="element-1057" data-mp="mfwfovx8ejdr">
                    <Building size={24} data-id="element-1058" data-mp="cquzp5qos1zs" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-1059" data-mp="cp1tfrjzjjsb">
                    Main Office
                  </h2>
                </div>

                <div className="space-y-4 text-brand-muted" data-id="element-1060" data-mp="157fgcw3s9lcm">
                  <div className="flex items-start gap-3" data-id="element-1061" data-mp="1590fkz11lsgt">
                    <MapPin size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1062" data-mp="2pw9qlb2nskgy" />
                    <p data-id="element-1063" data-mp="2zne5kasc45bs">
                      MidAtlantic Mailbox, Inc
                      <br data-id="element-1064" data-mp="2zpgvyvxeg0h1" />
                      4507 Metropolitan Court Ste D<br data-id="element-1065" data-mp="2uo1d9aip261t" />
                      Frederick, MD 21704
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1066" data-mp="26zi3srnwrn85">
                    <Phone size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1067" data-mp="21zvpeewcg0xr" />
                    <p data-id="element-1068" data-mp="2gyhbo80uneu3">
                      <a href="tel:301-620-7585" className="hover:text-brand-maroon transition-colors" data-id="element-1069" data-mp="2gujqlgupod7k">
                        301-620-7585
                      </a>{' '}
                      or{' '}
                      <a href="tel:301-620-7867" className="hover:text-brand-maroon transition-colors" data-id="element-1070" data-mp="3ncglne7blq46">
                        301-620-7867
                      </a>
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1071" data-mp="25vi1h8hlo9t9">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1072" data-mp="2ave2qzywxn54" />
                    <p data-id="element-1073" data-mp="2ftxn4vxuyqvd">
                      Monday - Friday: 10:30AM - 5:00PM (EST)
                      <br data-id="element-1074" data-mp="2kss926r4gvjp" />
                      Closed on Saturdays and Sundays
                    </p>
                  </div>
                  <div className="flex items-start gap-3 pt-2" data-id="element-1075" data-mp="2plbufpw1wuz2">
                    <Mail size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1076" data-mp="2tl2hpjmdcsyu" />
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-brand-maroon hover:text-brand-maroonDark font-medium break-all" data-id="element-1077" data-mp="2yj43icb6j6e0">
                      customerservice@midatlanticmailboxes.com
                    </a>
                  </div>

                  <div className="mt-2 bg-brand-goldWash border border-brand-gold/40 rounded-lg p-4 flex items-start gap-3" data-id="element-1078" data-mp="33piycf7oae3p">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1079" data-mp="2zpsaokdg0e3e" />
                    <p className="text-sm text-brand-charcoal leading-relaxed" data-id="element-1080" data-mp="3rfn0ei57q5sl">
                      <strong data-id="element-1081" data-mp="3rhpzrss99b9z">After-hours support:</strong> If you need help
                      after regular office hours, call{' '}
                      <a href="tel:240-575-5852" className="text-brand-maroon font-semibold hover:underline" data-id="element-1082" data-mp="3inutuijb7gta">
                        240-575-5852
                      </a>
                      . Available until 8 PM Eastern Time.
                    </p>
                  </div>
                </div>
              </div>

              {/* Internet & Commercial Sales */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1083" data-mp="2dfihjpyqoz2w">
                <div className="flex items-center gap-3 mb-6" data-id="element-1084" data-mp="1yqdzq9vuwwvb">
                  <div className="w-12 h-12 rounded-full bg-brand-background text-brand-maroon flex items-center justify-center" data-id="element-1085" data-mp="23pqk8nz99ruq">
                    <Globe size={24} data-id="element-1086" data-mp="1ppo6ndxzdkla" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-1087" data-mp="1upaltsxddawq">
                    Internet & Commercial Sales
                  </h2>
                </div>

                <div className="space-y-4 text-brand-muted" data-id="element-1088" data-mp="1funwkjc6tufu">
                  <div className="flex items-start gap-3" data-id="element-1089" data-mp="1ks5xpnjyr5da">
                    <Phone size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1090" data-mp="3a6khruk1e42g" />
                    <div className="space-y-1" data-id="element-1091" data-mp="3f4vqu32icajm">
                      <p data-id="element-1092" data-mp="13hsgrfo42o3f">
                        <strong data-id="element-1093" data-mp="13j3k5edn9tu0">Eastern region:</strong>{' '}
                        <a href="tel:240-575-5852" className="hover:text-brand-maroon transition-colors" data-id="element-1094" data-mp="yiz6dw44fd7h">
                          240-575-5852
                        </a>
                      </p>
                      <p data-id="element-1095" data-mp="18f23uoo12no3">
                        <strong data-id="element-1096" data-mp="1m89wmjnuhp7d">Western region:</strong>{' '}
                        <a href="tel:480-505-9240" className="hover:text-brand-maroon transition-colors" data-id="element-1097" data-mp="1m6qgct26ve5l">
                          480-505-9240
                        </a>
                      </p>
                      <p data-id="element-1098" data-mp="1r8o3hydpmt3t">
                        <strong data-id="element-1099" data-mp="1r8fpu49rjjrk">Toll Free:</strong>{' '}
                        <a href="tel:800-469-1203" className="hover:text-brand-maroon transition-colors" data-id="element-1100" data-mp="1rwvmxl76pto">
                          800-469-1203
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1101" data-mp="3c3lxuiicb8de">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1102" data-mp="3gvwwzj59aq4w" />
                    <p data-id="element-1103" data-mp="3lu6yebhkqmyy">
                      Monday - Friday: 9:00AM to 5:00PM (MST)
                      <br data-id="element-1104" data-mp="2o89i8kqo2tq6" />
                      <span className="text-sm italic" data-id="element-1105" data-mp="2o92jx7arqt1g">
                        Please note we have an East Coast & West Coast office
                        that operate in different time zones.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Team */}
        <section className="py-16 bg-white border-b border-brand-border" data-id="element-1106" data-mp="den6pgwjxcm0">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1107" data-mp="icyivyabjz7e">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-1108" data-mp="22w29yv6iekst">
              Our Team
            </h2>
            <p className="text-center text-brand-muted mb-10 max-w-2xl mx-auto" data-id="element-1109" data-mp="1xwpc7fe3ntbg">
              Please feel free to contact any one of our team members directly
              via email or phone at{' '}
              <a href="tel:301-620-7585" className="text-brand-maroon hover:underline" data-id="element-1110" data-mp="1o64gbzpt92w8">
                301-620-7585
              </a>
              .
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1111" data-mp="1f5ogd08a0dw4">
              {[{
              name: 'Anne Ingram',
              title: 'Chief Executive Officer & Owner',
              email: 'anne@midatlanticmailbox.biz'
            }, {
              name: 'Lora Dragovich',
              title: 'Lead Commercial & E Commerce Sales Manager',
              email: 'lorad@midatlanticmailboxes.com'
            }, {
              name: 'Brooke Ingram',
              title: 'Operations Manager & Street Sign Specialist',
              email: 'brooke@midatlanticmailbox.biz'
            }, {
              name: 'Rachel Ingram-Conway',
              title: 'Business Development & Residential Specialist',
              email: 'rachel@midatlanticmailbox.biz'
            }].map((member, idx) => <div key={idx} className="bg-brand-background p-6 rounded-xl border border-brand-border text-center flex flex-col items-center" data-id="element-1112" data-mp="37km97jvxsa3i" data-mpi={idx}>
                  <div className="w-14 h-14 rounded-full bg-brand-goldWash text-brand-maroon flex items-center justify-center mb-4" data-id="element-1113" data-mp="3gk8zpan4nvhs">
                    <User size={24} data-id="element-1114" data-mp="2stvg88ilz4yt" />
                  </div>
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-1115" data-mp="2ou4l5sm1u2oh">
                    {member.name}
                  </h3>
                  <p className="text-sm text-brand-muted mb-4 flex-grow" data-id="element-1116" data-mp="2eowb9sumevwi">
                    {member.title}
                  </p>
                  <a href={`mailto:${member.email}`} className="text-sm text-brand-maroon hover:text-brand-maroonDark font-medium break-all" data-id="element-1117" data-mp="2jih7bfcnlft2">
                    {member.email}
                  </a>
                </div>)}
            </div>
          </div>
        </section>

        {/* Services & Communities */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1118" data-mp="32eh4d4khn9ji">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1119" data-mp="2nhgcn12arel1">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1120" data-mp="2sgszhlt64lnm">
              <div data-id="element-1121" data-mp="2sj5nogpirs94">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1122" data-mp="1c2t1whhsp83j">
                  Your Mailbox Experts Are Here to Help!
                </h2>
                <ul className="space-y-4 text-brand-muted" data-id="element-1123" data-mp="1h37ca66vcu4q">
                  <li className="flex items-start gap-3" data-id="element-1124" data-mp="3jouil4oyhcpo">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1125" data-mp="3jqdy2t2sfjqe" />
                    <span className="text-lg" data-id="element-1126" data-mp="39xgnra7y912v">
                      Replacement CBU's & New Developments
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1127" data-mp="300lnals48qly">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1128" data-mp="30254cellj5os" />
                    <span className="text-lg" data-id="element-1129" data-mp="2qzdtoh0jody7">
                      Advisal of Commercial Postal Codes & Ordinances
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1130" data-mp="2m35i1dlk32vs">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1131" data-mp="p77sjkx8uyy9" />
                    <span className="text-lg" data-id="element-1132" data-mp="rt8h15t7wfid">
                      Value Engineered Development Mailbox Mapping
                    </span>
                  </li>
                </ul>
              </div>

              <div data-id="element-1133" data-mp="11j1tsa53j0o7">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1134" data-mp="11ii9wnvvy27j">
                  Communities Serviced by Midatlantic Mailbox
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 text-brand-muted" data-id="element-1135" data-mp="8u4d2bgj9bxk">
                  <a href="/3948.html" className="flex items-center gap-2 hover:text-brand-maroon transition-colors" data-id="element-1136" data-mp="dt7d1hhnoryo">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1137" data-mp="iud7pkuvmpau" />
                    Regency at Dominion Valley: Haymarket, VA
                  </a>
                  <div className="flex items-center gap-2" data-id="element-1138" data-mp="1u6e33im8xbzk">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1139" data-mp="1z6imbgejgkth" />
                    Lenah Mills: Aldie, VA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1140" data-mp="1wr3s3fvt46yd">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1141" data-mp="1wtorzzcjocth" />
                    Skeeter Lake: Roundhill, VA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1142" data-mp="26qbbokt4wxtx">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1143" data-mp="21qygncs40kg9" />
                    Brunswick Crossing: Frederick, MD
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1144" data-mp="2fpofawukus6q">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1145" data-mp="2bp4khzxh80nr" />
                    Villages at Urbana: Frederick, MD
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1146" data-mp="2pf7yy4q46q2n">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1147" data-mp="2khpzr61wfp7u" />
                    Greencastle Green: Greencastle, PA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1148" data-mp="2zf8inrrwb87d">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1149" data-mp="2ug5nr05mqid4" />
                    Copper Run Drive: Monroe, LA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1150" data-mp="3e1xhdrebphcp">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1151" data-mp="3i3iyxq1syjt8" />
                    Regency at Trotter's Point: Tinton Falls, NJ
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1152" data-mp="3945s7552c9c7">
          <div className="max-w-4xl mx-auto px-4" data-id="element-1153" data-mp="2ubbyaep1nqo0">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-1154" data-mp="2z4eu6thanc7d">
              Frequently Asked Questions
            </h2>

            <div className="space-y-6" data-id="element-1155" data-mp="2laxb19sis1hv">
              {/* General / Install */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1156" data-mp="2qc34j9u07ssg">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1157" data-mp="2bfcgfwps63i5">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1158" data-mp="2gcvsqr2x467g" />
                  I didn’t buy my mailbox from Midatlantic Mailbox. Will you
                  still install it?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7" data-id="element-1159" data-mp="1nkael5rjvwc8">
                  It depends! If you are in our service area and there is
                  availability on our schedule, we can complete a direct burial
                  installation. However we can only guarantee the craftsmanship
                  of the physical installation; any issues with the products
                  should be brought to the company you purchased from. Call{' '}
                  <a href="tel:301-620-7585" className="text-brand-maroon hover:underline" data-id="element-1160" data-mp="21anld4sph4zz">
                    301-620-7585
                  </a>{' '}
                  to request an installation today!
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1161" data-mp="31j3ug0cejzbv">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1162" data-mp="36hx0x8t9uq2j">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1163" data-mp="3bh9vyguar3g7" />
                  Do I need post office approval to replace my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7" data-id="element-1164" data-mp="3l5rs2krmsmdi">
                  Unless you’re moving your mailbox location, you generally
                  don’t need USPS approval to complete a residential
                  installation. We’ll ensure your mailbox is compliant with USPS
                  regulations during installation. All of Midatlantic Mailbox’s
                  products are also USPS Approved.
                </p>
              </div>

              {/* 4C Mailboxes */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1165" data-mp="24tmemsjpgwwg">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1166" data-mp="ajo04nyj95o0">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1167" data-mp="5kl7k2zqorwx" />
                  Are 4C mailboxes USPS approved?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7 mb-4" data-id="element-1168" data-mp="fcqx762iqx8y">
                  Yes, 4C mailboxes are the newest USPS code-approved systems,
                  made per USPS regulations outlined in the Federal Registry. 4C
                  mailboxes meet or exceed STD-4C requirements for new
                  construction and major renovations.
                </p>
                <div className="pl-7 space-y-4" data-id="element-1169" data-mp="3sq2ntemlstzl">
                  <div data-id="element-1170" data-mp="3ssf6ju06r8dp">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1171" data-mp="1cyy10dr00lk9">
                      How are they installed?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1172" data-mp="17zbq4ayn7hem">
                      Preferred installation is recessed into the wall, however
                      there is a surface-mounted or a depot option available.
                      Both may require USPS approval.
                    </p>
                  </div>
                  <div data-id="element-1173" data-mp="16l0uck660zns">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1174" data-mp="1akjh7lhjrkt9">
                      Are they ADA approved?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1175" data-mp="1ybf2s0vetjs2">
                      4C Mailboxes are produced to meet USPS code; ADA is a
                      separate entity. There are full USPS & ADA compliant units
                      available. Call 301-620-7585 to connect with a 4C
                      specialist.
                    </p>
                  </div>
                  <div data-id="element-1176" data-mp="2h8g85msvllwj">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1177" data-mp="2h86hdx00baps">
                      What is a Parcel locker and is it required?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1178" data-mp="hfodab4ueb4g">
                      A Parcel Locker is required for all USPS package
                      deliveries. To be compliant, it must be 15” tall. For
                      every 10 tenant slots, 5 parcel lockers are required by
                      USPS Code.
                    </p>
                  </div>
                  <div data-id="element-1179" data-mp="cmljq302f1o9">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1180" data-mp="3uukslsok8wl1">
                      Lead times & Customization?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1181" data-mp="3pkz87g49nq3">
                      Production varies from 4-6 weeks depending on quantity and
                      colors. There are limited custom options available.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4B+ Mailboxes */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1182" data-mp="1o3v0uivq1hme">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1183" data-mp="38lvt8lockwhc">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1184" data-mp="33mt0o0pk0iq9" />
                  Are Horizontal or Vertical (4B+) mailboxes USPS approved?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7 mb-4" data-id="element-1185" data-mp="3dkpberekxbnu">
                  No, 4B+ Horizontal and Vertical mailboxes are not USPS
                  approved for new construction, renovations, or updates. As of
                  July 2020 USPS Code Amendments, any renovation requires an
                  upgrade to CBU or 4C systems. They are only considered
                  approved if replacing existing mailboxes (at the discretion of
                  your local Postmaster). We ALWAYS advise confirming with your
                  local USPS Postmaster prior to purchasing.
                </p>
                <div className="pl-7 space-y-4" data-id="element-1186" data-mp="21z0b0i6kb5sm">
                  <div data-id="element-1187" data-mp="5ukgz61qtnt2">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1188" data-mp="5v2oiytuvoga">
                      Customization & Installation?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1189" data-mp="av8janvf9r2l">
                      Limited options for horizontal, no custom options for
                      vertical. Vertical can be surface or recessed-mounted.
                      Horizontal must be recessed.
                    </p>
                  </div>
                  <div data-id="element-1190" data-mp="ts9oa8oz7r6j">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1191" data-mp="trgf712jopl8">
                      Lead times?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1192" data-mp="yjhyv821lila">
                      Horizontal units: 6-8 weeks. Vertical units: 7-14 business
                      days. Transit time depends on location.
                    </p>
                  </div>
                  <div data-id="element-1193" data-mp="1cihl69231lea">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1194" data-mp="1cjsq4c79kz6z">
                      What is included?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1195" data-mp="1mklc25bdzrvj">
                      Units include tenant locks with 2 keys each and number
                      slot card door ID per each door.
                    </p>
                  </div>
                </div>
              </div>

              {/* Street Signs */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1196" data-mp="25d6099g558t0">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1197" data-mp="25f0ey60tk4on">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1198" data-mp="1vncpubrqizqc" />
                  Street Sign FAQs
                </h3>
                <div className="pl-7 space-y-4" data-id="element-1199" data-mp="1rjy73dcew597">
                  <div data-id="element-1200" data-mp="2o4p0j8is68rc">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1201" data-mp="2o4yhy7prf7lf">
                      I only need a replacement part - what do I do?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1202" data-mp="23tvyondzu8ee">
                      Call Midatlantic Mailbox! Our sign specialist can identify
                      the replacement part needed via photos to provide an
                      estimate.
                    </p>
                  </div>
                  <div data-id="element-1203" data-mp="1ywvteeoyx9oc">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1204" data-mp="1ywckfnhapvmg">
                      How are street signs shipped?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1205" data-mp="2rl1ex3nuj2p8">
                      Full systems ship via Freight due to post length. Single
                      blades ship standard. We offer Telescoping Poles to save
                      on freight charges.
                    </p>
                  </div>
                  <div data-id="element-1206" data-mp="35k13ycf9tjlx">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1207" data-mp="35jhn6z1cx19h">
                      What materials are they made of?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1208" data-mp="yvqzywdu0lvv">
                      Most systems (blade, bracket, post, base) are derived from
                      durable aluminum.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policies */}
        <section className="py-16 lg:py-24 bg-brand-charcoal text-white" data-id="element-1209" data-mp="13o23083vcnsn">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1210" data-mp="fwd3a6opwx1o">
            <div className="text-center mb-12" data-id="element-1211" data-mp="fz91zx8e3pr6">
              <FileText size={40} className="text-brand-gold mx-auto mb-4" data-id="element-1212" data-mp="ayv4h94ezy7e" />
              <h2 className="text-3xl font-serif font-bold mb-4" data-id="element-1213" data-mp="pv2ni6436tl3">
                Our Policies
              </h2>
              <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-1214" data-mp="kvzrfb633xp9">
                Please review our return, damage, and cancellation policies. For
                excellent customer service, contact us at{' '}
                <a href="tel:240-575-5852" className="text-brand-gold hover:underline" data-id="element-1215" data-mp="1wc7oix2qygtj">
                  240-575-5852
                </a>{' '}
                or{' '}
                <a href="tel:301-620-7585" className="text-brand-gold hover:underline" data-id="element-1216" data-mp="28c4j3y2lb8i1">
                  301-620-7585
                </a>
                .
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1217" data-mp="1ko4w998eg28q">
              {/* Returns */}
              <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1218" data-mp="1pn7qdymuco1x">
                <h3 className="text-xl font-bold text-brand-gold mb-3 flex items-center gap-2" data-id="element-1219" data-mp="1pl3iz6pqh6ww">
                  <AlertTriangle size={20} data-id="element-1220" data-mp="1uk7vo7bv9mrz" />
                  Return Policy
                </h3>
                <ul className="space-y-3 text-sm text-gray-300" data-id="element-1221" data-mp="1zf40k827c4mi">
                  <li data-id="element-1222" data-mp="11wu4yqyrhngb">
                    • Email{' '}
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-white hover:underline" data-id="element-1223" data-mp="16wgiz2mez7q6">
                      customerservice@midatlanticmailboxes.com
                    </a>{' '}
                    to obtain a return authorization number (RGA#). RGA is
                    required for all returns.
                  </li>
                  <li data-id="element-1224" data-mp="367qgdb1nrpy9">
                    • Returns must be made within 30 days from receipt, in new
                    condition, and original packaging.
                  </li>
                  <li data-id="element-1225" data-mp="2whnml8mpq7yv">
                    • Minimum restocking fee of 25% or $25 applies. Many
                    manufacturers may not allow returns if the item is not
                    defective.
                  </li>
                  <li data-id="element-1226" data-mp="2nhigr2x63hmt">
                    • Shipping charges for the return are the customer's
                    responsibility. Original shipping charges are
                    non-refundable.
                  </li>
                  <li data-id="element-1227" data-mp="2djum0czkaa4n">
                    • Products that have been installed or customized are not
                    returnable.
                  </li>
                  <li data-id="element-1228" data-mp="a8o6kanrxns3">
                    • Call{' '}
                    <a href="tel:800-806-7997" className="text-white hover:underline" data-id="element-1229" data-mp="a850br7hkntw">
                      800-806-7997
                    </a>{' '}
                    to determine your return requirements.
                  </li>
                </ul>
              </div>

              {/* Damages & Cancellations */}
              <div className="space-y-8" data-id="element-1230" data-mp="3ng9gr8wk5l3i">
                <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1231" data-mp="39o1nhr4hgc9k">
                  <h3 className="text-xl font-bold text-brand-gold mb-3" data-id="element-1232" data-mp="39lypajt6fctr">
                    Damage Inspections
                  </h3>
                  <p className="text-sm text-gray-300 mb-3" data-id="element-1233" data-mp="2zpdibsxljrna">
                    <strong data-id="element-1234" data-mp="2zrylqmdjmfn5">
                      All items must be inspected for concealed damage or
                      shortage within 3 days of delivery to receive credit.
                    </strong>
                  </p>
                  <p className="text-sm text-gray-300" data-id="element-1235" data-mp="2h1ux94ddkbr6">
                    Report damages, defects, or shipping errors within 3
                    business days by calling{' '}
                    <a href="tel:800-806-7997" className="text-white hover:underline" data-id="element-1236" data-mp="2uz00kwlpewiq">
                      1-800-806-7997
                    </a>
                    . Damaged products must be left in the original box with
                    packing materials. Do not discard any items; a shipping
                    representative may need to inspect them. Orders returned or
                    discarded without authorization will NOT be refunded.
                  </p>
                </div>

                <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1237" data-mp="3nqjnaqhiesph">
                  <h3 className="text-xl font-bold text-brand-gold mb-3" data-id="element-1238" data-mp="3irzymibj72tf">
                    Custom Orders & Cancellations
                  </h3>
                  <p className="text-sm text-gray-300 mb-3" data-id="element-1239" data-mp="nxvjckd9benx">
                    <strong data-id="element-1240" data-mp="j2g5vtj5vks1">Custom Orders:</strong> Address plaques,
                    personalized mailboxes, or engraved items are non-refundable
                    unless damaged/defective. America’s Finest and Bacova
                    mailboxes are made to order by hand and are non-returnable.
                  </p>
                  <p className="text-sm text-gray-300" data-id="element-1241" data-mp="53ghmmzk97we">
                    <strong data-id="element-1242" data-mp="af2cdvfz6ca">Cancellations:</strong> Many products ship within
                    24-48 hrs. To cancel, notify us immediately at{' '}
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-white hover:underline" data-id="element-1243" data-mp="3revgiq5me4ww">
                      customerservice@midatlanticmailboxes.com
                    </a>
                    . If shipped, you are responsible for return shipping and
                    restocking fees.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1244" data-mp="1y027ju76x72u" />
      <MobileStickyBar data-id="element-1245" data-mp="22xlox2z6pzz0" />
    </div>;
}